<template>
  <div class="login-container">
    <!-- Tarjeta principal -->
    <div class="login-card">
      <!-- Logo y branding -->
      <div class="card-logo">
        <div class="logo login-page-logo" alt="gestion360"></div>
      </div>
      
      <!-- Título de la tarjeta -->
      <div class="card-title">
        <h2>Acceso</h2>
      </div>
      
      <!-- Cuerpo de la tarjeta -->
      <div class="card-body">
        <!-- Mensaje de error -->
        <div v-if="error" class="alert-message" role="alert">
          <i class="bi bi-exclamation-circle"></i>
          {{ error }}
        </div>

        <!-- Formulario de login -->
        <form @submit.prevent="handleLogin">
          <!-- Campo de usuario -->
          <div class="form-group">
            <label for="UsuarioId" class="form-label">Usuario</label>
            <div class="input-wrapper">
              <i class="bi bi-person-fill input-icon"></i>
              <input
                type="text"
                class="form-input"
                id="UsuarioId"
                v-model="UsuarioId"
                required
                autocomplete="username"
                placeholder="Ingrese su ID de usuario"
              >
            </div>
          </div>

          <!-- Campo de contraseña -->
          <div class="form-group">
            <label for="Password" class="form-label">Contraseña</label>
            <div class="input-wrapper">
              <i class="bi bi-shield-lock-fill input-icon"></i>
              <input
                type="password"
                class="form-input"
                id="Password"
                v-model="Password"
                required
                autocomplete="current-password"
                placeholder="Ingrese su contraseña"
              >
            </div>
          </div>

          <!-- Botón de login -->
          <div class="login-button-container">
            <button type="submit" class="login-button" :disabled="loading">
              <span v-if="loading" class="spinner"></span>
              <span v-else class="button-content">
                <i class="bi bi-box-arrow-in-right"></i>
                <span>Iniciar Sesión</span>
              </span>
            </button>
          </div>
          
          <!-- Enlace de recuperación de contraseña -->
          <div class="forgot-password-link">
            <a href="#" @click.prevent="forgotPassword" class="text-link">¿Olvidaste tu contraseña?</a>
          </div>
          

        </form>
        
        <!-- Enlace comercial -->
        <div class="commercial-link">
          <a href="https://tangentemexico.com" target="_blank" class="commercial-text">Desarrollado por Sistemas Tangente del Norte</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/shared/services/auth';
import { useAccessControl } from '@/composables/useAccessControl';

export default {
  name: 'LoginView',
  setup() {
    // Variables de control de acceso - LoginView no requiere ninguna condición
    const accessControl = useAccessControl({
      requiresAuth: false,
      requiresMenuPermission: false
    });
    
    return {
      ...accessControl
    };
  },
  data() {
    return {
      UsuarioId: '',
      Password: '',
      loading: false,
      error: null
    };
  },
  created() {
    // Si el usuario ya está autenticado, redirigir al dashboard
    if (authService.isAuthenticated()) {
      this.$router.push('/');
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.error = null;

      try {
        const response = await authService.login(this.UsuarioId, this.Password);
        if (response.Success) {
          // Redirigir al dashboard después de un login exitoso
          this.$router.push('/');
        } else {
          this.error = response.Message || 'Error al iniciar sesión';
        }
      } catch (error) {
        console.error('Error de login:', error);
        this.error = 'Error al conectar con el servidor';
      } finally {
        this.loading = false;
      }
    },
    forgotPassword() {
      // Implementación futura para recuperar contraseña
      console.log('Recuperar contraseña');
    }
  }
};
</script>
